import {
  Alert,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Paper,
  Stack,
  Typography
} from "@mui/material";
import { useState } from "react";
import {
  useESocialGovStatus,
  useESocialJTStatus
} from "../../api/ESocialJTServiceApi";
import { authRequired, getSessionStatus } from "../../shared/keycloak";
import { dataExibicao } from "../../shared/apresentacaoEvento";
export default function Status({ onClose }) {
  const [open, setOpen] = useState(false);
  const service = useESocialJTStatus(open);
  const gov = useESocialGovStatus(open);
  const sessao = getSessionStatus();
  const fechar = () => {
    setOpen(false);
    onClose();
  };
  return (
    <>
      <MenuItem onClick={() => setOpen(true)}>
        <ListItemIcon>
          <Icon fontSize="small">monitor_heart</Icon>
        </ListItemIcon>
        <ListItemText>Status do sistema</ListItemText>
      </MenuItem>
      <Dialog open={open} onClose={fechar} fullWidth maxWidth="sm">
        <DialogTitle>Status do sistema</DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            <Typography variant="body2" color="text.secondary">
              Disponibilidade dos serviços e situação da sua sessão.
            </Typography>
            <Linha label="Conector eSocial" query={service} />
            <Linha label="Comunicação com o eSocial" query={gov} />
            <Paper variant="outlined" sx={{ p: 2 }}>
              <Stack direction="row" justifyContent="space-between">
                <Typography>Sessão de acesso</Typography>
                <Chip
                  size="small"
                  label={
                    !authRequired
                      ? "Não configurada"
                      : sessao.authenticated
                      ? "Autenticada"
                      : "Expirada"
                  }
                  color={
                    !authRequired
                      ? "default"
                      : sessao.authenticated
                      ? "success"
                      : "warning"
                  }
                />
              </Stack>
              {sessao.expiresAt && (
                <Typography variant="caption" color="text.secondary">
                  Validade atual: {dataExibicao(sessao.expiresAt * 1000)} ·
                  renovação automática antes das requisições
                </Typography>
              )}
            </Paper>
            <Alert severity="info">
              A disponibilidade do serviço não confirma que todas as entregas
              foram processadas. Consulte também as pendências da Folha.
            </Alert>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              service.refetch();
              gov.refetch();
            }}
            disabled={service.isFetching || gov.isFetching}
          >
            Verificar novamente
          </Button>
          <Button onClick={fechar}>Fechar</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
function Linha({ label, query: q }) {
  const up = q.data?.status === "UP";
  const desconhecido = !q.data?.status;
  const status = q.isFetching
    ? "Verificando…"
    : q.error
    ? "Consulta indisponível"
    : desconhecido
    ? "Sem informação"
    : up
    ? "Disponível"
    : "Indisponível";
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack direction="row" justifyContent="space-between" gap={2}>
        <Typography>{label}</Typography>
        <Chip
          size="small"
          label={status}
          color={
            q.error
              ? "warning"
              : q.isFetching || desconhecido
              ? "default"
              : up
              ? "success"
              : "error"
          }
        />
      </Stack>
      {q.error && (
        <Typography variant="caption" color="error">
          {q.error.message}
        </Typography>
      )}
      {q.data?.details?.mensagem && (
        <Typography variant="caption" color="text.secondary" display="block">
          {q.data.details.mensagem}
        </Typography>
      )}
      {q.dataUpdatedAt > 0 && (
        <Typography variant="caption" color="text.secondary">
          Verificado em {dataExibicao(q.dataUpdatedAt)}
        </Typography>
      )}
    </Paper>
  );
}
